import { clientService } from '../_services';

const getDefaultState = () => {
  return {
    current: {}
  }
}

export const clients = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    resetState ({ commit }) {
      commit('resetState')
    },
    getById({ commit }, clientId) {
      commit('getByIdRequest');
      clientService.getById(clientId)
      .then(
          clients => commit('getByIdSuccess', client),
          error => commit('getByIdFailure', error)
      );
    },
    getCurrentClient({ commit }, slug) {
      commit('getCurrentClientRequest');

      let subdomain =  window.location.host.split('.')[1] ? window.location.host.split('.')[0] : "demo"; // "dcd33d07-6d77-4fb9-86d9-0b9cb5a88159";

      if(slug){
        subdomain = slug;
      }

      clientService.getCurrentClient(subdomain)
      .then(
          client => commit('getCurrentClientSuccess', client),
          error => commit('getCurrentClientFailure', error)
      );
    }
  },
  mutations: {
    resetState (state) {
      Object.assign(state, getDefaultState())
    },
    getByIdRequest(state) {
      state.current = { loading: true };
    },
    getByIdSuccess(state, client) {
      state.current = client;
    },
    getByIdFailure(state, error) {
        state.current = { error };
    },
    getCurrentClientRequest(state) {
      state.current = { loading: true };
    },
    getCurrentClientSuccess(state, client) {
      state.current = client;
    },
    getCurrentClientFailure(state, error) {
      state.current = { error };
    },
  }
}